import { render, staticRenderFns } from "./DistributeRecordDialog.vue?vue&type=template&id=53afdbee&scoped=true"
import script from "./DistributeRecordDialog.vue?vue&type=script&lang=js"
export * from "./DistributeRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./DistributeRecordDialog.vue?vue&type=style&index=0&id=53afdbee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53afdbee",
  null
  
)

export default component.exports